/* 本国サイトのcolumn-carousel.jsを元にLiquidベースの記述に変更 */

const isMobile = window.matchMedia('(max-width: 768px)');

function bindEvents(block) {
  if (block.dataset.carouselInitialized === 'true') return;

  const slideButtons = block.querySelectorAll('button');
  const slides = block.querySelectorAll('.carousel-slide');
  const carouselList = block.querySelector('.column-carousel .carousel-slides');
  const scrollBar = block.querySelector('.column-carousel nav');
  const scrollBarIndicator = scrollBar?.querySelector(
    '.carousel-slide-indicator',
  );

  if (!carouselList || slides.length === 0 || !scrollBar || !scrollBarIndicator) return;

  slideButtons[0]?.classList.add('disabled');
  slideButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const slideWidth = slides[0].clientWidth;
      const gap = slides[1].offsetLeft - slideWidth - carouselList.offsetLeft;
      const direction = button.id === 'prev-slide' ? -1 : 1;
      let scrollAmount = 0;
      if (isMobile.matches) {
        scrollAmount = (slideWidth + gap) * direction;
        const diff = carouselList.scrollLeft % scrollAmount;
        if (diff > 0) {
          scrollAmount = direction < 0 ? diff * direction : scrollAmount - diff;
        }
      } else {
        scrollAmount = (carouselList.clientWidth + gap) * direction;
      }
      carouselList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });

  const updateScrollBarPosition = () => {
    const maxWidth = carouselList.scrollWidth - carouselList.clientWidth;
    const scrollPosition = carouselList.scrollLeft;
    const barPosition = (scrollPosition / maxWidth)
      * (scrollBar.clientWidth - scrollBarIndicator.offsetWidth);
    scrollBarIndicator.style.left = `${barPosition}px`;

    slideButtons[0]?.classList.toggle('disabled', carouselList.scrollLeft <= 0);
    slideButtons[1]?.classList.toggle('disabled', carouselList.scrollLeft >= maxWidth);
  };

  carouselList.addEventListener('scroll', () => {
    updateScrollBarPosition();
  });

  // Enable drag-to-scroll behavior on desktop.
  let isDragging = false;
  let dragStartX = 0;
  let dragStartScrollLeft = 0;

  carouselList.addEventListener('mousedown', (event) => {
    isDragging = true;
    carouselList.classList.add('active');
    dragStartX = event.pageX - carouselList.offsetLeft;
    dragStartScrollLeft = carouselList.scrollLeft;
  });

  carouselList.addEventListener('mouseleave', () => {
    isDragging = false;
    carouselList.classList.remove('active');
  });

  carouselList.addEventListener('mouseup', () => {
    isDragging = false;
    carouselList.classList.remove('active');
  });

  carouselList.addEventListener('mousemove', (event) => {
    if (!isDragging) return;
    event.preventDefault();
    const currentX = event.pageX - carouselList.offsetLeft;
    const walk = (currentX - dragStartX) * 3;
    carouselList.scrollLeft = dragStartScrollLeft - walk;
  });

  const resizeCarousel = () => {
    updateScrollBarPosition();
    // hide nav if no need
    const showNav = carouselList.clientWidth > block.querySelector('.carousel-slide:last-child').offsetLeft;
    block.classList.toggle('nav-disabled', showNav);
  };

  window.addEventListener('resize', resizeCarousel);

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) {
      observer.disconnect();
      // hide nav if no need
      const showNav = carouselList.clientWidth > block.querySelector('.carousel-slide:last-child').offsetLeft;
      block.classList.toggle('nav-disabled', showNav);
    }
  });
  observer.observe(carouselList);
  block.dataset.carouselInitialized = 'true';
}

function initializeExistingColumnCarousels() {
  const blocks = document.querySelectorAll('.column-carousel-container .column-carousel');
  blocks.forEach((block) => bindEvents(block));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeExistingColumnCarousels);
} else {
  initializeExistingColumnCarousels();
}
